import type { PhotoPickerCopy } from './types';

export const DEFAULT_PHOTO_PICKER_COPY: PhotoPickerCopy = {
  triggerEmptyLabel: 'Tap to upload your photo(s)',
  triggerAddMoreLabel: 'Edit photos',
  triggerEditTileLabel: 'Edit photo selection & order',
  drawerHeading: 'Confirm these are the photos you want to use',
  drawerSubDescription: 'Hold and drag any photo to reorder',
  dropzoneEmptyBody: 'Add more photos',
  dropzoneAddMoreLabel: 'Add more photos',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  deleteLabel: 'Remove photo',
  retryLabel: 'Retry upload',
  uploadingLabel: 'Uploading…',
  uploadErrorMessage: 'Image(s) failed to upload: please retry later',
  drawerUploadErrorMessage: 'Image(s) failed to upload: please retry later or remove them',
  presignErrorMessage: "We couldn't prepare the upload. Please try again.",
  minPhotosMessage: 'Please add at least {min} photo{pluralS}.',
  unsavedChangesMessage:
    'You have unsaved changes to your photos. Confirm to apply them, or cancel to discard.',
};
